export const colors = {
  navActiveBtnBackground: "#FFDB21",
  navButtonText: "#013B5A",
};
  
export const fonts = {
};

export const mediaQueries = {
  mobile: "@media screen and (max-width: 700px)",
  notMobile: "@media screen and (min-width: 701px)",
  notTablet: "@media screen and (min-width: 901px)",
  tablet: "@media screen and (max-width: 900px)"
};
  
